import type { CourierType } from '@/domains/mobile-web/constant/listStatusCourier.constant';
import type { AdminOrderParams, OrderDisplayStatus, TransferStatus } from '../types/order.types';

/** Badge colours (STATUS_COURIER key) per order status; the label itself comes from the API. */
export const ORDER_STATUS_BADGE: Record<OrderDisplayStatus, CourierType> = {
  pending: 'waiting',
  processing: 'process',
  shipped: 'delivery',
  arrived: 'come',
  completed: 'finish',
  cancelled: 'cancel',
  refunded: 'cancel',
};

/** Semua Status dropdown of Riwayat Transaksi, in the order an order moves through. */
export const ORDER_STATUS_OPTIONS: { value: OrderDisplayStatus; label: string }[] = [
  { value: 'pending', label: 'Menunggu Pembayaran' },
  { value: 'processing', label: 'Diproses' },
  { value: 'shipped', label: 'Dikirim' },
  { value: 'arrived', label: 'Barang Sampai' },
  { value: 'completed', label: 'Selesai' },
  { value: 'cancelled', label: 'Dibatalkan' },
  { value: 'refunded', label: 'Dikembalikan' },
];

/** Status Bayar while a bank transfer is awaited. */
export const TRANSFER_STATUS_LABEL: Record<TransferStatus, string> = {
  awaiting_transfer: 'Menunggu Transfer',
  reported: 'Menunggu Konfirmasi',
  rejected: 'Transfer Tidak Ditemukan',
};

/** Menunggu Konfirmasi: unpaid, the customer reported the transfer; the admin checks the bank
 *  statement and confirms the payment. */
export const orderBadge = (order: {
  display_status: OrderDisplayStatus;
  transfer_status: TransferStatus | null;
}): CourierType =>
  order.transfer_status === 'reported'
    ? 'waitingConfirmation'
    : ORDER_STATUS_BADGE[order.display_status];

/** Menunggu Konfirmasi in the status dropdown: not a stored status but the reported transfers */
export const TRANSFER_REPORTED_OPTION = {
  value: 'transfer_reported',
  label: 'Menunggu Konfirmasi',
};

/** List filter for TRANSFER_REPORTED_OPTION: the longest waiting first */
export const REPORTED_TRANSFERS: AdminOrderParams = {
  transfer_status: 'reported',
  sort_by: 'transfer_reported_at',
  order: 'asc',
};
